export class ProductFilter {
  city: string;
  locality: number[] = [];
  priceRange: any[] = [];
  soryBy: string ="recent";
  productType: string = 'STANDARD';
  merchant: string = "";
  category: string = "";
}
